'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}(); // Store


var _uuid = require('uuid');

var _notification = require('../stores/notification.store');

var _notification2 = _interopRequireDefault(_notification);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Notify = function () {
  function Notify() {
    _classCallCheck(this, Notify);

    this.notifications = [];
  }

  _createClass(Notify, [{
    key: 'add',
    value: function add(_ref) {
      var title = _ref.title,
          content = _ref.content,
          closable = _ref.closable,
          icon = _ref.icon,
          primary = _ref.primary,
          secondary = _ref.secondary,
          id = _ref.id,
          closeOnOutsideClick = _ref.closeOnOutsideClick,
          loading = _ref.loading;
      var nID = id || (0, _uuid.v4)();
      if ([].concat(_toConsumableArray(this.notifications)).find(function (notification) {
        return notification.id === nID;
      }) !== undefined) return;
      this.notifications = [].concat(_toConsumableArray(this.notifications), [{
        id: nID,
        title: title,
        content: content,
        closable: closable,
        icon: icon,
        primary: primary,
        secondary: secondary,
        closeOnOutsideClick: closeOnOutsideClick,
        loading: loading
      }]);

      _notification2.default.pub([].concat(_toConsumableArray(this.notifications)));

      return this.remove.bind(this, nID);
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      this.notifications = [].concat(_toConsumableArray(this.notifications)).filter(function (notification) {
        return notification.id !== id;
      });

      _notification2.default.pub([].concat(_toConsumableArray(this.notifications)));
    }
  }]);

  return Notify;
}();

var notify = new Notify();

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$title = _ref2.title,
      title = _ref2$title === undefined ? 'No title defined' : _ref2$title,
      _ref2$content = _ref2.content,
      content = _ref2$content === undefined ? null : _ref2$content,
      _ref2$closable = _ref2.closable,
      closable = _ref2$closable === undefined ? true : _ref2$closable,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === undefined ? null : _ref2$icon,
      _ref2$primary = _ref2.primary,
      primary = _ref2$primary === undefined ? null : _ref2$primary,
      _ref2$secondary = _ref2.secondary,
      secondary = _ref2$secondary === undefined ? null : _ref2$secondary,
      _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _uuid.v4)() : _ref2$id,
      _ref2$closeOnOutsideC = _ref2.closeOnOutsideClick,
      closeOnOutsideClick = _ref2$closeOnOutsideC === undefined ? false : _ref2$closeOnOutsideC,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === undefined ? false : _ref2$loading;

  return notify.add({
    title: title,
    content: content,
    closable: closable,
    icon: icon,
    primary: primary,
    secondary: secondary,
    id: id,
    closeOnOutsideClick: closeOnOutsideClick,
    loading: loading
  });
};

var remove = exports.remove = function remove(id) {
  return notify.remove(id);
};